import dayjs from 'dayjs'

import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday"
dayjs.extend(weekOfYear).extend(weekday) // 获取周插件

import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
dayjs.extend(tz)
dayjs.tz.setDefault("Asia/Shanghai") // 设置时区

import "dayjs/locale/zh-cn" // 设置国区后 一周的开始时间为周一
dayjs.locale('zh-cn')

export default dayjs.tz